module.exports = __webpack_public_path__ + "static/media/9_r_derevo2_80.99_64.54.18995573.png";